angular.module('user-group')
    .directive('userGroupPicker', function ($filter, $document, $compile, $parse, UserGroup) {
        return {
            restrict: 'AE',
            require: '?ngModel',
            scope: {
                onChange: "&",
            },
            templateUrl: "app/user-group/picker/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.executeOnChange = scope.onChange || angular.noop
                scope.selected = ngModelCtrl.$modelValue || [];
                scope.userGroups = [];

                UserGroup.autocomplete().$promise.then(items => {
                    scope.userGroups = items;
                });

                scope.usersDropdownSettings = {
                    searchField: 'name',
                    enableSearch: true,
                    displayProp: 'name',
                    idProperty: 'id',
                    scrollable: true,
                    keyboardControls: true,
                    // styleActive: true
                };

                scope.dropdownMultiselectTranslations = {
                    checkAll: 'Zaznacz wszystko',
                    uncheckAll: 'Odznacz wszystko',
                    buttonDefaultText: '-- wybierz --',
                    searchPlaceholder: "szukaj..."
                };


                scope.$watchCollection(function () {
                    return ngModelCtrl.$modelValue;
                }, function (newValue, oldValue) {
                    if (oldValue != newValue) {
                        //update the view value with fresh data from items, if there is a valid model value
                        if (angular.isDefined(ngModelCtrl.$modelValue)) {
                            ngModelCtrl.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                        }
                        scope.seleced = ngModelCtrl.$modelValue;
                    }
                });
                ngModelCtrl.$render = () => {
                    // Make sure that model value is array
                    if (!angular.isArray(ngModelCtrl.$viewValue)) {
                        // Have tolerance for null or undefined values
                        if (angular.isUndefined(ngModelCtrl.$viewValue) || ngModelCtrl.$viewValue === null) {
                            ngModelCtrl.$viewValue = [];
                        } else {
                            throw Exception("Expected model value to be array but got '{0}'", ngModelCtrl.$viewValue);
                        }
                    }
                    scope.selected = ngModelCtrl.$viewValue;
                };

                ngModelCtrl.$isEmpty = modelValue => !angular.isArray(modelValue) || modelValue.length === 0;

                scope.events = {
                    onSelectionChanged: () => {
                        ngModelCtrl.$setDirty();
                        ngModelCtrl.$setViewValue(scope.selected);
                        ngModelCtrl.$validate();
                        if(angular.isFunction(scope.executeOnChange())){
                            scope.executeOnChange()(scope.selected);
                        }
                    }
                }
            }
        }
    })
